module.exports = __webpack_public_path__ + "static/img/pass_大数据.470b1bd3.png";